export default __webpack_public_path__ + "static/media/need-help.c3059dc3.png";